import type { Translations } from '../keys';

const enUS: Translations = {
  'common.search': 'Search',
  'common.copied': 'Copied',
  'common.copy': 'Copy',
  'common.poweredBy': 'Powered by',
  'common.plan': 'Plan',
  'common.banner': 'Banner',
  'common.total': 'Total {value}',
  'common.installmentPrefix': '{count}x of',
  'common.discountCoupon': 'Coupon',
  'common.checkout': 'Checkout',
  'common.tryAgain': 'Try again',

  'app.loading': 'Loading checkout…',
  'app.init.error': 'Unable to initialize checkout:',

  'checkout.title': 'Complete your subscription',
  'checkout.subtitle': 'Fill in your details to unlock access to {productName}.',
  'checkout.greeting': 'We\'re glad to see you, {firstName}',
  'checkout.contactInfo': 'Contact information',
  'checkout.contact.namePlaceholder': 'Full name',
  'checkout.paymentMethod': 'Payment method',
  'checkout.cardData': 'Card details',
  'checkout.card.maskPlaceholder': '•••• •••• •••• ••••',
  'checkout.card.expMonth': 'Month',
  'checkout.card.expYear': 'Year',
  'checkout.card.cvv': 'CVV',
  'checkout.card.expiryPlaceholder': 'MM/YY',
  'checkout.card.holderName': 'Cardholder full name',
  'checkout.document': 'Document',
  'checkout.document.cpfHolder': 'Cardholder CPF',
  'checkout.useFilledName': 'Use the name I already entered',
  'checkout.summary.ariaLabel': 'Subscription summary',
  'checkout.summary.community': 'Community',
  'checkout.summary.availablePlans': 'Available plans',
  'checkout.summary.chooseAccess': 'Choose your access',
  'checkout.summary.buying': 'You are purchasing:',
  'checkout.summary.renewal': 'Renews on {date}. You can cancel anytime.',
  'checkout.theme.enableLight': 'Enable light theme',
  'checkout.theme.enableDark': 'Enable dark theme',
  'checkout.theme.light': 'Light',
  'checkout.theme.dark': 'Dark',
  'checkout.installments.title': 'Installments',
  'checkout.installments.placeholder': 'Number of installments',
  'checkout.installments.discount': '{percent}% OFF',
  'checkout.submit.generatePix': 'Generate PIX code',
  'checkout.submit.buyLifetime': 'Buy {productName} (lifetime access)',
  'checkout.submit.subscribe': 'Subscribe to {productName}',
  'checkout.footer.safeTransaction': 'Secure and encrypted transaction',
  'checkout.footer.termsPrefix': 'By confirming your purchase, you agree to the',
  'checkout.footer.terms': 'Ginastee Terms of Use',

  'checkout.notFound.eyebrow': 'Checkout unavailable',
  'checkout.notFound.title': 'Community not found',
  'checkout.notFound.description': 'This checkout link does not belong to an active community. Check the address or contact the community.',

  'checkout.paymentsUnavailable.message': 'Payments for your region are not available yet — the community owner needs to finish setting up their wallet.',
  'checkout.paymentsUnavailable.action': 'Learn how',

  'coupon.title': 'Discount coupon',
  'coupon.placeholder': 'Enter coupon',
  'coupon.notFound': 'Coupon not found',

  'pix.title': 'Complete your payment with PIX',
  'pix.instructions': 'Open an app where you have PIX enabled, choose Pay, then Scan QR code.',
  'pix.scanQrCode': 'Scan the QR code below in your banking app',
  'pix.qrAlt': 'PIX QR code',
  'pix.copyCode': 'Or, if you prefer, copy and paste the code below',
  'pix.timeLeft': 'Time left to pay:',
  'pix.realtime': 'Updated in real time',

  'thanks.confirming.title': 'Confirming payment',
  'thanks.confirming.description': 'We are waiting for payment confirmation before releasing access.',
  'thanks.failed.title': 'Payment not confirmed',
  'thanks.failed.description': 'We could not confirm your payment. Try again or contact support.',
  'thanks.success.title': 'Congratulations!',
  'thanks.success.subtitle': 'You subscribed to {productName}',
  'thanks.success.emailSent': 'An email with your platform access link has been sent to you.',
  'thanks.success.emailMissing': 'Still haven\'t received the email?',
  'thanks.success.emailDelay': 'The registration email usually arrives within 5 minutes.',
  'thanks.success.spamSupport': 'If that time has passed, check your spam folder or send a message to the support channel.',
  'thanks.success.supportButton': 'The email hasn\'t arrived yet',

  'method.creditCard': 'Credit card',
  'method.pix': 'PIX',

  'input.fullName.placeholder': 'Enter your full name',
  'input.phone.placeholder': 'Mobile phone number',
  'input.country.searchPlaceholder': 'Search country',
  'input.date.label': 'Date',
  'input.date.placeholder': 'mm/dd/yyyy',
  'input.cpf.placeholder': '000.000.000-00',
  'input.money.label': 'Amount',
  'input.money.placeholder': '$0.00',
  'input.cnpj.label': 'Company document',
  'input.cnpj.placeholder': '00.000.000/0000-00',
  'input.email.placeholder': 'email@example.com',
  'input.cardNumber.label': 'Card number',
  'input.cardNumber.placeholder': '0000 0000 0000 0000',

  'address.label': 'Address',
  'address.placeholder': 'Search your address',
  'address.noOptions': 'No address found',
  'address.number.label': 'Number',
  'address.number.placeholder': 'No.',
  'address.complement.label': 'Additional details',
  'address.complement.placeholder': 'Apt, unit...',
  'address.neighborhood.label': 'Neighborhood',
  'address.zipcode.label': 'ZIP code',
  'address.zipcode.placeholder': '00000',
  'address.city.label': 'City',
  'address.state.placeholder': 'State',

  'stripe.error.generic': 'There was a payment error. Check the entered details and try again.',
  'stripe.error.incompleteCard': 'Complete the card details to continue',
  'stripe.error.confirmPayment': 'We could not confirm the payment',
  'stripe.submit': 'Confirm payment',

  'payment.error.generic': 'There was a payment error. Check the entered details and try again.',
  'payment.error.prepare': 'There was an error preparing the payment. Check the entered details and try again.',
  'payment.error.missingCharge': 'Payment charge identifier was not returned',
  'payment.error.notApproved': 'Payment was not approved. Check your card details and try again.',

  'validation.cardNumber': 'Correct the card number',
  'validation.cardExpiration': 'Invalid expiration date',
  'validation.cardExpired': 'Card has expired',
  'validation.cardCvv': 'Invalid CVV',
  'validation.cpf': 'Invalid CPF',
  'validation.fullName': 'Invalid full name',
  'validation.fullNameLettersOnly': 'Name must contain letters only',
  'validation.emailRequired': 'Email is required',
  'validation.emailInvalid': 'Invalid email',
  'validation.phoneRequired': 'Phone number is required',
  'validation.phoneInvalid': 'Invalid phone number',
  'validation.phoneDigits': 'Phone number must have 10 or 11 digits',
  'validation.phoneMobileStartsWithNine': 'Mobile number must start with 9',
  'validation.phoneDdd': 'Invalid area code',

  'interval.week.adjective': 'Weekly',
  'interval.month.adjective': 'Monthly',
  'interval.bimonthly.adjective': 'Every two months',
  'interval.quarterly.adjective': 'Quarterly',
  'interval.semiannual.adjective': 'Semiannual',
  'interval.year.adjective': 'Yearly',
  'interval.lifetime.adjective': 'Lifetime',
  'interval.week.noun': 'Week',
  'interval.month.noun': 'Month',
  'interval.bimonthly.noun': 'Two months',
  'interval.quarterly.noun': 'Quarter',
  'interval.semiannual.noun': 'Six months',
  'interval.year.noun': 'Year',
  'interval.lifetime.noun': 'Lifetime',
  'interval.lifetime.access': 'lifetime access',
  'interval.period': 'period',

  'month.01': 'January',
  'month.02': 'February',
  'month.03': 'March',
  'month.04': 'April',
  'month.05': 'May',
  'month.06': 'June',
  'month.07': 'July',
  'month.08': 'August',
  'month.09': 'September',
  'month.10Label': 'October',
  'month.11Label': 'November',
  'month.12': 'December',
};

export default enUS;
